<template>
  <div
    v-on-arrow-tab
    class="clinic-panel"
  >
    <p
      v-if="importantNotification"
      class="clinic-panel__important-notification"
    >
      <span>{{ importantNotification }}</span>
      <router-link v-bind:to="{ name: 'ClinicPanelTariffs' }">
        Перейти к оплате
      </router-link>
    </p>
    <head-panel
      v-bind:call-hover-message="callHoverMessage"
      v-bind:call-list-access="callListAccess"
      v-bind:is-profile-loaded="isProfileLoaded"
      v-bind:messengers-access="messengersAccess"
      v-bind:whats-app-access="whatsAppAccess"
      v-on:logout="logout()"
      v-on:hover-calls="reloadActiveCallCount"
      v-on:show-active-calls="reloadActiveCalls"
      v-on:show-whats-app-chat="reloadChats"
      v-on:show-messengers-chats-dialog="showMessengersChatsDialog"
    >
      <template v-slot:updates-button>
        <updates-modal
          v-if="isMobile && isShowUpdateButton"
          v-bind:is-show-init="isShowUpdateModal"
          v-bind:list-updates="listUpdates"
          v-on:update-vote="updateVote"
        />
      </template>
      <template v-slot:body>
        <div
          v-if="hasBranchedClinics"
          class="head-panel__body__select-clinics"
          v-on:click.stop
        >
          <input-select
            need-use-custom-item
            option-description-key='address'
            option-title-key='name'
            option-value-key='id'
            title=''
            v-bind:menu-props="{
              top: isMobile,
              offsetY: true,
              maxWidth: '360px',
              minWidth: !isMobile ? '300px' : '',
            }"
            v-bind:options="branchedClinics"
            v-bind:value="selectedBranchId"
            v-on:input="onSelectBranch"
          />
        </div>
        <div class="head-panel__buttons">
          <button
            v-if="!isMobile"
            class="head-panel__button suggestion"
            type="button"
            v-on:click="onShowSuggestionIdeaPopup">Предложить идею
          </button>
          <updates-modal
            v-if="!isMobile && isShowUpdateButton"
            class="head-panel__body__updates"
            v-bind:is-show-init="isShowUpdateModal"
            v-bind:list-updates="listUpdates"
            v-on:update-vote="updateVote"
          />
        </div>
        <modal-dialog
          v-model="shownSuggestionIdeaPopup"
          content-class="suggestion-idea-popup"
          title="Вместе делаем программу лучше!"
          with-cross>
          <p>Внедряем 5 и более идей клиентов ежемесячно</p>
          <form
            class="clinic-panel__idea"
            v-on:submit.prevent="onSubmitSuggestionIdea">
            <textarea-length-limitation
              v-model="suggestionIdeaDescription"
              class="clinic-panel__idea__text"
              placeholder="Текст вашего сообщения"
              rows="5"
              show-counter
              v-bind:max-length="1000" />
            <InputMultiplyFiles
              v-model="suggestionFiles"
            />
            <p class="inputErrorMessage">{{ inputErrors }}</p>
            <div class="clinic-panel__idea__buttons">
              <button
                class="clinic-panel__idea__button-cancel"
                type="button"
                v-bind:disabled="isSuggestionIdeaAwaitRequest"
                v-on:click="onCloseSuggestionIdeaPopup">Отмена
              </button>
              <button
                class="clinic-panel__idea__button-submit"
                type="submit"
                v-bind:disabled="isSuggestionIdeaSubmitButtonDisabled">Предложить
              </button>
            </div>
          </form>
        </modal-dialog>
        <header-burger-menu-list
          v-bind:alerts="alerts"
          v-bind:counters="counters"
          v-bind:is-show-alerts="isShowAlerts"
          v-bind:is-show-counters="isShowCounters"
          v-bind:navigate-items="navigateItems"
          v-on:logout="logout()"
          v-on:show-suggestion-idea-popup="onShowSuggestionIdeaPopup()"
        />
      </template>
    </head-panel>
    <div class="clinic-panel__body">
      <left-navbar
        v-bind:alerts="alerts"
        v-bind:counters="counters"
        v-bind:is-profile-loaded="isProfileLoaded"
        v-bind:is-show-alerts="isShowAlerts"
        v-bind:is-show-counters="isShowCounters"
        v-bind:navigate-items="navigateItems"
        v-on:toggle-sub-menu="toggleSubMenu"
      />
      <side-slide-left-to-right-transition>
        <div
          v-if="showSubNavigation"
          v-click-outside="closeSubMenu"
          class="clinic-panel__left-side-menu__sub"
        >
          <button
            class="clinic-panel__left-side-menu__sub__collapse"
            title="Закрыть подменю"
            type="button"
            v-on:click="closeSubMenu" />
          <template
            v-for="{
              name, to, classes,
            } in subNavigation"
          >
            <router-link
              v-bind:key="name"
              :class="[{ 'link-alert': isShowAlerts(name) }, ...classes]"
              class="clinic-panel__left-side-menu__sub__link"
              v-bind:to="to"
              v-on:click="closeSubMenu"
            >
              <span
                v-if="isShowAlerts(name)"
                class="clinic-panel__left-side-menu__item__exclamation-mark-alert mark-alert"
                title="Заполните все недостающие данные">
                !
              </span>
              {{ name }}
            </router-link>
          </template>
        </div>
      </side-slide-left-to-right-transition>
      <slot />
      <on-boarding-window
        v-if="isShowOnBoardingWindow"
        :list-steps="listOnBoardingSteps"
      />
      <div
        v-if="appointmentCopy"
        class="clinic-panel__appointment-copy"
      >
        <span class="clinic-panel__appointment-copy__title">
          {{ getCopyAppointmentInfo }}
          <button
            class="clinic-panel__appointment-copy__delete"
            title="Очистить"
            type="button"
            v-on:click="cleanAppointmentCopy"
          />
        </span>
      </div>
    </div>
    <mobile-popup />
    <incoming-call-list
      v-if="isShowCallList"
      v-click-outside="onHideIncomingCallList"
      class="clinic-panel__call-list"
      v-bind:calls="activeCallList"
      v-on:copy-patient="onCopyPatient"
      v-on:open-patient-creation-form="onOpenPatientCreationForm"
      v-on:select-patient="onSelectPatientForIncomingCall"
    />
    <clinic-panel-dialog
      v-model="isShownDialog"
      v-bind:crossButtonClose="dialogCrossButton"
      v-bind:leftButtonType="dialogLeftButtonType"
      v-bind:rightButtonType="dialogRightButtonType"
      v-bind:title="dialogTitle"
      v-on:close-dialog="onCloseDialog"
    />
    <confirm-side-dialog
      v-if="isShowWhatsAppChat"
      label=""
      v-bind:size="'auto'"
      v-on:cancel="onHideWhatsAppChat"
    >
      <whats-app-client
        v-bind:chat-list="chatList"
        v-bind:has-chats="hasChats"
        v-bind:selected-chat="selectedChat"
        v-bind:selected-chat-id="selectedChatId"
        v-on:search="reloadChats"
        v-on:open-chat="openChat"
        v-on:send-message="sendMessage"
        v-on:delete-message="deleteMessage"
        v-on:forward-message="forwardMessage"
        v-on:close-chat="closeChat"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-if="shownWebMessengerDialog"
      class="messenger-dialog"
      label="Веб-Мессенджер"
      v-bind:size="'small'"
      v-on:cancel="onCloseWebMessengerDialog"
    >
      <div class="messenger-dialog__content">
        <iframe
          class="messenger-dialog__frame"
          title="Чаты"
          v-bind:src="webMessengerLink"
        />
      </div>
    </confirm-side-dialog>
  </div>
</template>
<script>
import { AUTH_LOGOUT, AUTH_SET_TOKEN } from '@/store/actions/auth';
import { NOTIFICATION_REQUEST } from '@/store/actions/notifications';
import HeadPanel from '@/components/HeadPanel.vue';
import focusArrowMixin from '@/mixins/focusArrowMixin';
import SideSlideLeftToRightTransition from '@/components/SideSlideLeftToRightTransition.vue';
import { APPOINTMENT_COPY, APPOINTMENT_ORDERS_COUNT } from '@/store/actions/appointments';
import { ACTIVE_TASK_COUNT, DELETE_TASK_FILTER } from '@/store/actions/tasks';
import LeftNavbar from '@/components/LeftNavbar.vue';
import HeaderBurgerMenuList from '@/components/HeaderBurgerMenuList.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import notifierMixin from '@/mixins/notifierMixin';
import IncomingCallList from '@/components/IncomingCallList.vue';
import WhatsAppClient from '@/components/WhatsAppClient.vue';
import debounce from 'lodash.debounce';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import { SendFileRequest } from '@/storage/gateways/WhatsAppGateway';
import ClinicPanelDialog, { dialogMixin } from '@/components/ClinicPanelDialog.vue';
import { WHATS_APP_NOTIFICATION_REQUEST } from '@/store/actions/whatsAppNotifications';
import mobileMixin from '@/mixins/mobileMixin';
import OnBoardingWindow from '@/components/OnBoardingWindow.vue';
import { FETCH_STEPS } from '@/store/actions/onBoarding';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import MobilePopup from '@/components/MobilePopup.vue';
import UpdatesModal from '@/components/UpdatesModal.vue';
import { USER_SET_HAS_SETTINGS_ERRORS } from '@/store/actions/user';
import { CLEAR_SCHEDULE_QUERY } from '@/store/actions/schedule';
import InputSelect from '@/components/InputSelect.vue';
import branchMixin from '@/mixins/branchMixin';
import InputMultiplyFiles from '@/components/InputMultiplyFiles.vue';
import {
  EventBus,
  NAME_EVENT_OPEN_MESSENGERS_CHAT,
  NAME_EVENT_OPEN_WHATS_APP_CHAT,
} from '@/utils/eventBus';
import { SERVER_MESSAGES_SET_TOKEN } from '@/store/actions/serverMessages';
import { appointmentCopyMixin } from '@/mixins/appointmentMixin';
import { EVENT_INVOICE_CREATING } from '@/components/ServerMessageInvoiceCreating.vue';
import { EVENT_PATIENT_CAME } from '@/components/ServerMessagePatientCame.vue';

/**
 * @description Примесь мессенджеров.
 * @type {Vue}
 */
const messengersMixin = {
  created() {
    EventBus.$on(NAME_EVENT_OPEN_MESSENGERS_CHAT, async (phone) => {
      await this.showMessengersChatDialog(phone);
    });
  },
  beforeDestroy() {
    EventBus.$off(NAME_EVENT_OPEN_MESSENGERS_CHAT, this.showMessengersChatDialog);
  },
  computed: {
    /**
     * @description Доступ к Мессенджерам.
     * @type {boolean}
     */
    messengersAccess() {
      return this.availableSectionList.includes('messengers');
    },
  },
  data() {
    return {
      webMessengerLink: '',
      shownWebMessengerDialog: false,
    };
  },
  methods: {
    /**
     * @description Показать диалоговое окно списка чатов Мессенджеров.
     * @returns {Promise<void>}
     */
    async showMessengersChatsDialog(phone = '') {
      if (this.webMessengerLink !== '') {
        this.addPhoneToLink(phone);
        this.shownWebMessengerDialog = true;
        return;
      }
      const onFail = ({ title }) => {
        this.notifyFail(title);
      };
      const onSuccess = ({ link }) => {
        this.webMessengerLink = link;
        if (phone) {
          this.addPhoneToLink(phone);
        }
        this.shownWebMessengerDialog = true;
      };
      this
        .$messengersIntegrationGateway
        .getWebMessengerLink()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description показать диалоговое окно чата Мессенджеров.
     * @param {string} phone
     * @returns {Promise<void>}
     */
    async showMessengersChatDialog(phone) {
      if (this.webMessengerLink === '') {
        await this.showMessengersChatsDialog(phone);
        return;
      }
      this.addPhoneToLink(phone);
      this.shownWebMessengerDialog = true;
    },
    /**
     * @desription Удалить телефон из ссылки.
     */
    removePhoneFromLink() {
      if (!this.webMessengerLink) {
        return;
      }
      const url = new URL(this.webMessengerLink);
      url.searchParams.delete('phone');
      this.webMessengerLink = url.toString();
    },
    /**
     * @description Добавление телефона в ссылку.
     */
    addPhoneToLink(phone) {
      if (!this.webMessengerLink) {
        return;
      }
      const phoneWithoutDelimiters = phone.replace(/\D/g, '');
      const url = new URL(this.webMessengerLink);
      if (phoneWithoutDelimiters) {
        url.searchParams.set('phone', phoneWithoutDelimiters);
      }
      this.webMessengerLink = url.toString();
    },
    /**
     * @description Обработать закрытие диалогового окна Веб-Мессенджера.
     * @returns {void}
     */
    onCloseWebMessengerDialog() {
      this.shownWebMessengerDialog = false;
      this.removePhoneFromLink();
    },
  },
};

/**
 * @description Примесь предложения идеи.
 * @type {Vue}
 */
const suggestionIdeaMixin = {
  computed: {
    /**
     * @description Кнопка отправки формы деактивирована.
     * @type {boolean}
     */
    isSuggestionIdeaSubmitButtonDisabled() {
      if (this.isSuggestionIdeaAwaitRequest) {
        return true;
      }
      return this.suggestionIdeaDescription.length < 3;
    },
  },
  data() {
    return {
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isSuggestionIdeaAwaitRequest: false,
      /**
       * @description Показывать попап.
       * @type {boolean}
       */
      shownSuggestionIdeaPopup: false,
      /**
       * @description Описание идеи.
       * @type {string}
       */
      suggestionIdeaDescription: '',
      /**
       * @description Прикрепленные файлы к идее в форме
       * @type {array}
       */
      suggestionFiles: [],
      /**
       * Ошибки при отправке формы
       */
      inputErrors: '',
    };
  },
  methods: {
    /**
     * @description Обработать открытие попапа.
     * @returns {void}
     */
    onShowSuggestionIdeaPopup() {
      this.shownSuggestionIdeaPopup = true;
    },
    /**
     * @description Обработать закрытие попапа.
     * @returns {void}
     */
    onCloseSuggestionIdeaPopup() {
      this.suggestionIdeaDescription = '';
      this.shownSuggestionIdeaPopup = false;
    },
    /**
     * @description Обработать отправку идеи.
     * @returns {void}
     */
    onSubmitSuggestionIdea() {
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.onCloseSuggestionIdeaPopup();
        this.suggestionFiles = [];
        this.inputErrors = '';
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.inputErrors = error.getTitle();
      };
      this.isSuggestionIdeaAwaitRequest = true;
      this
        .$userGateway
        .storeIdea(this.suggestionIdeaDescription, this.suggestionFiles)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isSuggestionIdeaAwaitRequest = false;
        });
    },
  },
};

/**
 * @description Примесь синхронизации токена.
 * @type {Vue}
 */
const syncTokenMixin = {
  created() {
    const key = 'user-token';
    /**
     * @param {StorageEvent} event Событие.
     * @returns {void}
     */
    const onStorageChanged = (event) => {
      if (event.key === key) {
        if (event.newValue === null) {
          this.logout();
        } else {
          this.$store.dispatch(AUTH_SET_TOKEN, event.newValue);
        }
      }
    };
    window.addEventListener('storage', onStorageChanged);
    this.$once(
      'hook:beforeDestroy',
      () => window.removeEventListener('storage', onStorageChanged),
    );
  },
};

/**
 * @description Примесь Whats App
 * @type {Vue}
 */
const whatsAppMixin = {
  created() {
    EventBus.$on(NAME_EVENT_OPEN_WHATS_APP_CHAT, async (phone) => {
      await this.reloadChats()
        .finally(() => {
          this.openChat(phone);
        });
    });
  },
  beforeDestroy() {
    EventBus.$off(NAME_EVENT_OPEN_WHATS_APP_CHAT, this.openChat);
  },
  computed: {
    /**
     * @description Доступ к чату Whats App
     * @type {boolean}
     */
    whatsAppAccess() {
      return this.availableSectionList.includes('whats-app');
    },
    /**
     * @description Чаты имеются
     * @returns {boolean}
     */
    hasChats() {
      return this.chatList.length > 0;
    },
  },
  data() {
    return {
      isShowWhatsAppChat: false,
      chatList: [],
      selectedChatId: '',
      selectedChat: null,
      /**
       * @description Ожидание окончания запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
    };
  },
  methods: {
    /**
     * @description Скрыть чат
     * @returns {void}
     */
    onHideWhatsAppChat() {
      this.isShowWhatsAppChat = false;
      this.selectedChat = null;
      this.selectedChatId = '';
    },
    /**
     * @description Перезагрузить список чатов.
     * @returns {Promise<void>}
     */
    async reloadChats(searchQuery = '') {
      if (this.awaitLoadingMatchedChats) {
        return;
      }
      const onSuccess = (list) => {
        this.chatList = list;
        this.isShowWhatsAppChat = true;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.awaitLoadingMatchedChats = true;
      this
        .$whatsAppGateway
        .getChatList(searchQuery)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.awaitLoadingMatchedChats = false;
        });
    },
    /**
     * @description Открыть чат с пользователем.
     * @param {string} chatId
     * @returns {void}
     */
    openChat(chatId) {
      this.selectedChatId = chatId;
      this.getChat();
    },
    /**
     * @description Получить чат для просмотра.
     * @returns {void}
     */
    getChat() {
      if (!this.selectedChatId || this.isAwaitRequest) {
        return;
      }
      this.isAwaitRequest = true;
      const onSuccess = (chat) => {
        this.selectedChat = chat;
        this.isAwaitRequest = false;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.isAwaitRequest = false;
      };
      this
        .$whatsAppGateway
        .getChat(this.selectedChatId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Закрыть чат.
     * @returns {void}
     */
    closeChat() {
      this.selectedChat = null;
      this.selectedChatId = null;
    },
    /**
     * @description Отправить файл.
     * @param {string} text
     * @param {string} chatId
     * @param {string} quotedMessageId
     * @param {Object} file
     * @returns {void}
     */
    sendMessage(text, chatId, quotedMessageId, file) {
      const onSuccess = (data) => {
        this.notifySuccess(data.title);
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const request = new SendFileRequest(text, chatId, file, quotedMessageId);
      this
        .$whatsAppGateway
        .sendMessage(request)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Удалить сообщение
     * @param {string} messageId
     * @param {string} chatId
     * @returns {void}
     */
    deleteMessage(messageId, chatId) {
      const onSuccess = (data) => {
        this.notifySuccess(data.title);
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$whatsAppGateway
        .deleteMessage(messageId, chatId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Пересылка сообщения
     * @param {string}  forwardTo
     * @param {string}  forwardFrom
     * @param {string}  messageId
     * @returns {void}
     */
    forwardMessage(forwardTo, forwardFrom, messageId) {
      const onSuccess = (data) => {
        this.notifySuccess(data.title);
        this.selectedChatId = forwardTo;
        this.getChat();
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$whatsAppGateway
        .forwardMessage(forwardTo, forwardFrom, messageId)
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
  watch: {
    selectedChat: debounce(
      function fetch() {
        this.getChat();
      },
      4000,
    ),
    chatList: debounce(
      function fetch() {
        if (this.isShowWhatsAppChat) {
          this.reloadChats();
        }
      },
      9500,
    ),
  },
};

/**
 * @description Примесь звонков.
 * @type {Vue}
 */
const callMixin = {
  computed: {
    /**
     * @description Доступ к списку звонков.
     * @type {boolean}
     */
    callListAccess() {
      return this.availableSectionList.includes('calls');
    },
  },
  data() {
    return {
      activeCallList: [],
      isShowCallList: false,
      callHoverMessage: '',
    };
  },
  methods: {
    onHideIncomingCallList() {
      this.isShowCallList = false;
    },
    /**
     * @description Обработать копирование пациента.
     * @param {number}  callId              Идентификатор звонка.
     * @param {number}  patientId           Идентификатор пациента.
     * @param {string}  surnameWithInitials Фамилия с инициалами пациента.
     * @param {string}  age                 Возраст пациента.
     * @param {boolean} isArchive           Архивность пациента.
     * @returns {void}
     */
    onCopyPatient(callId, patientId, surnameWithInitials, age, isArchive) {
      if (isArchive) {
        this.notifyFail('Установлен запрет записи на прием');
        return;
      }
      const appointmentCopy = {
        callId,
        patientId,
        source: 'patient',
        patientName: surnameWithInitials,
        patientAge: age,
      };
      this.$store.dispatch(APPOINTMENT_COPY, appointmentCopy);
      // this.notifySuccessLong(
      //   'Пациент скопирован.'
      //   + ' Нажмите правой кнопкой мыши на нужный слот времени в расписании и вставьте запись.',
      // );
    },
    /**
     * @description Обработать открытие формы создания пациента.
     * @param {string} phoneNumber
     * @returns {void}
     */
    onOpenPatientCreationForm(phoneNumber) {
      this.$router.push({
        name: 'ClinicPanelFormCreatePatient',
        params: { initialPhoneNumber: phoneNumber },
      });
    },
    /**
     * @description Обработать выбор пациента.
     * @param {number} callId
     * @param {number} patientId
     * @returns {void}
     */
    onSelectPatientForIncomingCall(callId, patientId) {
      const onFail = (error) => this.notifyFail(error.getTitle());
      const onSuccess = (title) => {
        this.reloadActiveCalls();
        this.notifySuccess(title);
      };
      this
        .$telephonyIntegrationGateway
        .clarifyIncomingCallPatient(callId, patientId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Перезагрузить список активных звонков.
     * @returns {void}
     */
    reloadActiveCalls() {
      const onSuccess = (list) => {
        this.activeCallList = list;
        this.isShowCallList = true;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$telephonyIntegrationGateway
        .viewActivePatientCallList()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Перезагрузить количество активных звонков.
     * @returns {void}
     */
    reloadActiveCallCount: debounce(function _() {
      const onSuccess = ({ message }) => {
        this.callHoverMessage = message;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$telephonyIntegrationGateway
        .viewActivePatientCallCount()
        .then((result) => result.fold(onFail, onSuccess));
    }, 3000, {
      maxWait: 300,
      leading: true,
      trailing: true,
    }),
  },
};

/**
 * @description Примесь уведомлений.
 * @type {Vue}
 */
const serverMessagesMixin = {
  created() {
    this.$serverMessages.connect();
    this
      .$serverMessages
      .subscribe(EVENT_INVOICE_CREATING, this.notifyServerMessage)
      .subscribe(EVENT_PATIENT_CAME, this.notifyServerMessage)
      .subscribe('refresh', this.onRefresh);
  },
  beforeDestroy() {
    this
      .$serverMessages
      .unsubscribe(EVENT_INVOICE_CREATING, this.notifyServerMessage)
      .unsubscribe(EVENT_PATIENT_CAME, this.notifyServerMessage)
      .unsubscribe('refresh', this.onRefresh);
  },
  methods: {
    onRefresh() {
      const onResponse = ({ token }) => {
        this.$store.dispatch(SERVER_MESSAGES_SET_TOKEN, token).then(() => {
          this.$serverMessages.connect();
        });
      };
      this
        .$userGateway
        .issueTokenForSubscribeToServerMessages()
        .then((result) => result.forEach(onResponse));
    },
  },
};

export default {
  components: {
    InputMultiplyFiles,
    InputSelect,
    UpdatesModal,
    MobilePopup,
    OnBoardingWindow,
    ConfirmSideDialog,
    HeadPanel,
    HeaderBurgerMenuList,
    IncomingCallList,
    LeftNavbar,
    ModalDialog,
    SideSlideLeftToRightTransition,
    TextareaLengthLimitation,
    WhatsAppClient,
    ClinicPanelDialog,
  },
  computed: {
    /**
     * @description Показываем окно Онбординга.
     *
     * @return {boolean}
     */
    isShowOnBoardingWindow() {
      return !this.isAllStepsPassed()
        && !this.isMobile;
    },
    /**
     * Показать кнопку "Что нового"
     *
     * @return {boolean}
     */
    isShowUpdateButton() {
      return this.listUpdates.length > 0;
    },
    /**
     * @description Доступные секции.
     * @returns {string[]}
     */
    availableSectionList() {
      return this.$store.getters.getAvailableSections;
    },
    importantNotification() {
      return this.$store.getters.getImportantNotification;
    },
    /**
     * @description Элементы навигации.
     * @type {any[]}
     */
    navigateItems() {
      return this.navigation.reduce(
        (acc, link) => {
          const toNavigateItem = this.navigateItem(link);
          if (Array.isArray(link.sub)) {
            const filteredLinks = link.sub.filter(this.isAvailableLink);
            if (filteredLinks.length > 0) {
              acc.push(toNavigateItem(filteredLinks));
            }
          } else if (this.isAvailableLink(link)) {
            acc.push(toNavigateItem(false));
          }
          return acc;
        },
        [],
      );
    },
    /**
     * @description Показывать подпункты меню.
     * @type {boolean}
     */
    showSubNavigation: ({ subNavigation }) => subNavigation.length > 0,
    /**
     * @description Количества для индикатора меню
     * @return {any}
     */
    counters() {
      return [
        {
          name: 'Задачи',
          count: this.$store.getters.getActiveTaskCount,
        },
        {
          name: 'Расписание',
          count: this.$store.getters.getAppointmentOrdersCount,
        },
      ];
    },
    /**
     * @description Предупреждения для меню.
     * @returns {any}
     */
    alerts() {
      return [
        {
          name: 'Настройки',
          has_errors: this.$store.getters.hasSettingsErrors,
        },
        {
          name: 'Общие настройки',
          has_errors: this.$store.getters.hasSettingsErrors,
        },
      ];
    },
    isProfileLoaded() {
      return this.$store.getters.isProfileLoaded;
    },
  },
  async created() {
    this.$store.dispatch(FETCH_STEPS);
    this.fetchListUpdates();
    this.navigation = await Promise.all(this.$options.headLinks.map(this.makeNavigateItem));
    this.$storageChangeOn(this)('settings', () => {
      if (this.areBranchAvailable) {
        this.getBranchedClinics();
      }
    });
  },
  data() {
    return {
      currentNavigateItemName: '',
      subNavigation: [],
      navigation: [],
      ignoreNextClose: false,
      /**
       * @description Список Обновлений
       * @type Array
       */
      listUpdates: [],
      /**
       * @description Показывать ли модальное окно с обновлениями.
       * @type {boolean}
       */
      isShowUpdateModal: false,
    };
  },
  headLinks: [
    {
      icon: 'schedule.svg',
      name: 'Расписание',
      to: { name: 'ClinicPanelAppointmentScheduleEmployees' },
      alias: [
        'ClinicPanelAppointmentScheduleCabinetPeriod',
        'ClinicPanelAppointmentScheduleCabinets',
        'ClinicPanelAppointmentScheduleEmployeePeriod',
      ],
    },
    {
      icon: 'patients.svg',
      name: 'Пациенты',
      auth: 'schedule',
      to: { name: 'ClinicPanelPatientList' },
      alias: ['ClinicPanelFormCreatePatient'],
    },
    {
      auth: 'card-check',
      icon: 'chief.svg',
      name: 'ЕГИСЗ',
      to: { name: 'ClinicPanelChiefPhysicianVisitList' },
    },
    {
      auth: 'cashbox',
      icon: 'cashier.svg',
      name: 'Касса',
      to: { name: 'ClinicPanelCashbox' },
    },
    {
      auth: 'cashbox-without-online-check',
      icon: 'cashier.svg',
      name: 'Касса',
      to: { name: 'ClinicPanelCashbox' },
    },
    {
      icon: 'settings.svg',
      name: 'Настройки',
      sub: [
        {
          auth: 'sourcebooks',
          name: 'Общие настройки',
          to: { name: 'ClinicPanelSettings' },
          classes: [],
        },
        {
          auth: 'sourcebooks',
          name: 'Кресла',
          to: { name: 'ClinicPanelCabinetList' },
          classes: [],
        },
        {
          auth: 'sourcebooks',
          name: 'Роли',
          to: { name: 'ClinicPanelEmployeeRoleList' },
          classes: [],
        },
        {
          auth: 'employees',
          name: 'Сотрудники',
          to: { name: 'ClinicPanelEmployeeList' },
          classes: [],
        },
        {
          auth: 'appointment-settings',
          name: 'Расписание',
          to: { name: 'ClinicPanelAppointmentSettings' },
          classes: [],
        },
        {
          auth: 'cashbox-list',
          name: 'Касса',
          to: { name: 'ClinicPanelCashboxList' },
          classes: [],
        },
        {
          auth: 'manage-appointments',
          name: 'Источники пациентов',
          to: { name: 'ClinicPanelAdvertisingChannelList' },
          classes: ['last'],
        },
        {
          auth: 'work-schedule',
          name: 'График работы',
          to: { name: 'ClinicPanelWorkSchedule' },
          classes: [],
        },
        {
          name: 'Прайс',
          to: { name: 'ClinicPanelServicePriceList' },
          classes: [],
        },
        {
          auth: 'medcard-merging',
          name: 'Объединение карт',
          to: { name: 'ClinicPanelMedcardMerging' },
          classes: [],
        },
        {
          name: 'История действий',
          auth: 'employee-action-histories',
          to: { name: 'ClinicPanelEmployeeActionHistories' },
          classes: ['last'],
        },
        {
          name: 'Шаблоны протоколов лечения',
          to: { name: 'ClinicPanelDiaryTemplateList' },
          classes: [],
        },
        {
          auth: 'treatment-plan-templates',
          name: 'Шаблоны планов лечения',
          to: { name: 'ClinicPanelTreatmentPlanTemplateList' },
          classes: [],
        },
        {
          name: 'Шаблоны документов',
          to: { name: 'ClinicPanelClinicDocumentTemplateList' },
          classes: ['last'],
        },
        // {
        //   name: 'Интеграции',
        //   auth: 'integrations',
        //   to: { name: 'ClinicPanelIntegrationList' },
        //   classes: [],
        // },
        {
          auth: 'tariffs',
          icon: 'tariffs.svg',
          name: 'Тарифы',
          to: { name: 'ClinicPanelTariffs' },
          classes: ['last'],
        },
      ],
    },
    {
      auth: 'crm',
      icon: 'patients.svg',
      name: 'CRM',
      to: { name: 'ClinicPanelCrmFunnels' },
    },
    {
      icon: 'task.svg',
      auth: 'task-module',
      name: 'Задачи',
      to: { name: 'ClinicPanelTaskList' },
    },
    {
      icon: 'warehouse.svg',
      name: 'Склад',
      sub: [
        {
          name: 'Товары',
          auth: 'warehouse',
          to: { name: 'ClinicPanelWarehouseProductList' },
          classes: [],
        },
        {
          name: 'Поставщики',
          auth: 'warehouse',
          to: { name: 'ClinicPanelWarehouseVendorList' },
          classes: [],
        },
        {
          name: 'Поступление товаров',
          auth: 'warehouse',
          to: { name: 'ClinicPanelWarehouseProductArrivalList' },
          classes: [],
        },
        {
          auth: 'warehouse',
          name: 'Списание товаров',
          to: { name: 'ClinicPanelWarehouseProductWriteOffList' },
          classes: [],
        },
        {
          auth: 'warehouse',
          name: 'Единицы измерения',
          to: { name: 'ClinicPanelWarehouseProductUnitList' },
          classes: [],
        },
      ],
    },
    {
      icon: 'report.svg',
      name: 'Отчеты',
      sub: [
        {
          auth: 'dashboard',
          name: 'Кабинет руководителя',
          to: { name: 'ClinicPanelReportDashboard' },
          classes: [],
        },
        {
          name: 'Выручка',
          auth: 'reports',
          to: { name: 'ClinicPanelReportDirectionsRevenue' },
          classes: [],
        },
        {
          name: 'Учет времени',
          auth: 'work-time-accounting',
          to: { name: 'ClinicPanelWorkTimeAccountJournal' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Источники',
          to: { name: 'ClinicPanelReportSalesSources' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Загруженность сотрудников',
          to: { name: 'ClinicPanelReportEmployeesWorkload' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Приемы: работа администратора',
          to: { name: 'ClinicPanelReportPatientsAdministrators' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Стоимость привлечения пациента',
          to: { name: 'ClinicPanelReportPatientAttractingCost' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Планы лечения',
          to: { name: 'ClinicPanelReportTreatmentPlans' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'По кассе',
          to: { name: 'ClinicPanelReportCashboxes' },
          classes: [],
        },
        {
          auth: 'report-payroll',
          name: 'Расчеты с сотрудником',
          to: { name: 'ClinicPanelReportEmployeesPayroll' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Возвращаемость пациентов',
          to: { name: 'ClinicPanelReportPatientReturnRate' },
          classes: [],
        },
        {
          auth: 'reports',
          name: 'Склад: остатки товара',
          to: { name: 'ClinicPanelReportWarehouseProductBalances' },
          classes: [],
        },
      ],
    },
    {
      icon: 'phone.svg',
      auth: 'calls',
      name: 'Телефония',
      to: { name: 'ClinicPanelCallHistory' },
    },
    {
      auth: 'payroll',
      icon: 'pay.svg',
      name: 'Расчет ЗП',
      to: { name: 'ClinicPanelEmployeePayroll' },
    },
    // {
    //   auth: 'notification-plans',
    //   icon: 'sms.svg',
    //   name: 'Рассылки',
    //   to: { name: 'ClinicPanelNotificationPlans' },
    // },
    {
      auth: 'loyalty-system',
      icon: 'wallet-icon.svg',
      name: 'Лояльность',
      to: { name: 'ClinicPanelLoyaltySystemSettings' },
    },
    {
      icon: 'help-menu.svg',
      name: 'Помощь',
      to: {},
    },
  ],
  methods: {
    /**
     * @description Закрыть подменю.
     * @returns {void}
     */
    closeSubMenu() {
      if (this.ignoreNextClose === true) {
        this.ignoreNextClose = false;
        return;
      }
      const navigateItem = this.findNavigateItem(
        this.navigateItems,
        this.$route.name,
      );
      this.currentNavigateItemName = navigateItem !== undefined ? navigateItem.name : '';
      this.subNavigation = [];
    },
    /**
     * @description Получить количество новых уведомлений.
     * @returns {void}
     */
    fetchNewNotificationCount() {
      const onResponse = (count) => this.$store.commit(NOTIFICATION_REQUEST, { count });
      this
        .$notificationGateway
        .viewNewNotificationCount()
        .then((result) => result.forEach(onResponse));
    },
    /**
     * @description Получить количество новых уведомлений Whats App.
     * @returns {void}
     */
    fetchNewWhatsAppNotificationCount() {
      if (this.whatsAppAccess) {
        const onResponse = (count) => this.$store.commit(WHATS_APP_NOTIFICATION_REQUEST, { count });
        this
          .$whatsAppGateway
          .viewNewNotificationCount()
          .then((result) => result.forEach(onResponse))
          .finally(() => {
            setTimeout(this.fetchNewWhatsAppNotificationCount, 600000);
          });
      }
    },
    /**
     * @description Получить список обновлений.
     * @returns {Promise<void>}
     */
    async fetchListUpdates() {
      const response = await this.$updatesGateway.viewUpdates();
      this.listUpdates = response.updates;
      this.isShowUpdateModal = response.statusUpdateModal;
    },
    /**
     * @description Найти элемент навигации по названию маршрута.
     * @param {any[]}  navigateItems Навигационные элементы.
     * @param {string} routeName     Название маршрута.
     * @returns {any|undefined}
     */
    findNavigateItem(navigateItems, routeName) {
      const matchByName = ({ to }) => to && to.name === routeName;
      const matchByAlias = ({ alias }) => alias && alias.includes(routeName);
      const matchBySub = ({ sub }) => sub && this.findNavigateItem(sub, routeName);
      return navigateItems
        .find((item) => matchByName(item) || matchByAlias(item) || matchBySub(item));
    },
    /**
     * @description Проверить доступность ссылки навигационного элемента.
     * @param {any} link Навигационный элемент.
     * @returns {boolean}
     */
    isAvailableLink(link) {
      return !link.auth || this.availableSectionList.includes(link.auth);
    },
    /**
     * @description Отображать индикатор количества
     * @param name
     */
    isShowCounters(name) {
      return this.counters.find((element) => element.name === name && element.count > 0);
    },
    /**
     * @description Отображать индикатор предупреждения.
     * @param name
     */
    isShowAlerts(name) {
      return this.alerts.find((element) => element.name === name && element.has_errors);
    },
    /**
     * @description Получить количество заявок на прием.
     * @returns {void}
     */
    getAppointmentOrdersCount() {
      this.$appointmentScheduleGateway.getAggregatorOrdersCount()
        .then((result) => {
          result.forEach(({ count }) => {
            this.$store.commit(APPOINTMENT_ORDERS_COUNT, count);
          });
        });
    },
    /**
     * @description Получить наличие ошибок настроек клиники.
     * @returns {void}
     */
    getClinicSettingsExistenceErrors() {
      this.$settingGateway.getHasClinicSettingsErrors()
        .then((result) => {
          result.forEach(({ hasSettingsErrors }) => {
            this.$store.commit(USER_SET_HAS_SETTINGS_ERRORS, hasSettingsErrors);
          });
        });
    },
    /**
     * @description Получить количество активных задач
     * @return {void}
     */
    getActiveTaskCount() {
      this.$taskGateway.getActiveTaskCount()
        .then((result) => {
          result.forEach(({ count }) => {
            this.$store.commit(ACTIVE_TASK_COUNT, count);
          });
        });
    },
    logout() {
      this.removeWidget();
      this.$store.dispatch(CLEAR_SCHEDULE_QUERY);
      this.$store.dispatch(DELETE_TASK_FILTER);
      this.$serverMessages.disconnect();
      this.$store.dispatch(AUTH_LOGOUT)
        .then(() => this.$router.push('/login'));
    },
    makeNavigateItem(link) {
      const iconUrl = new URL(`../assets/img/nav/${link.icon}`, import.meta.url).href;
      return {
        ...link,
        styles: { 'background-image': `url('${iconUrl}')` },
      };
    },
    navigateItem(link) {
      const current = link.name === this.currentNavigateItemName;
      return (sub) => ({
        ...link,
        classes: { current },
        sub,
      });
    },
    /**
     * @description Установить название для вкладки.
     * @param {any}    item Элемент навигации.
     * @param {string} name Название страницы.
     * @returns {void}
     */
    setTitleTab(item, name) {
      if (item) {
        if (item.to) {
          document.title = item.name;
        } else {
          const link = item.sub.find((el) => el.to && el.to.name === name);
          document.title = link ? link.name : 'МИС';
        }
      } else {
        document.title = 'МИС';
      }
    },
    /**
     * @description Переключить видимость подменю.
     * @param {string} name          Название навигационного элемента.
     * @param {any[]}  navigateItems Навигационные элементы подменю.
     */
    toggleSubMenu(name, navigateItems) {
      this.ignoreNextClose = this.subNavigation.length > 0 && this.currentNavigateItemName !== name;
      this.currentNavigateItemName = name;
      this.subNavigation = navigateItems;
    },
    /**
     * @description Обновить оценку по обновлению.
     * @param {number} updateId
     * @param {string} vote
     * @returns {void}
     */
    updateVote(updateId, vote) {
      this
        .$updatesGateway
        .rateUpdate(updateId, vote)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchListUpdates();
          });
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
          });
        });
    },
    /**
     * @description Удалить виджет.
     * @returns void
     */
    removeWidget() {
      Object.keys(localStorage)
        .forEach((key) => {
          if (key.startsWith('HDE_')) {
            localStorage.removeItem(key);
          }
        });
      const elements = document.querySelectorAll('[id^="hde-contact"]');
      elements.forEach((el) => el.remove());
    },
  },
  mixins: [
    appointmentCopyMixin,
    branchMixin,
    onBoardingMixin,
    callMixin,
    focusArrowMixin,
    serverMessagesMixin,
    messengersMixin,
    suggestionIdeaMixin,
    syncTokenMixin,
    notifierMixin,
    dialogMixin,
    whatsAppMixin,
    mobileMixin,
  ],
  name: 'ClinicPanelLayout',
  watch: {
    isProfileLoaded: {
      handler(value) {
        if (value) {
          this.getAppointmentOrdersCount();
          this.getActiveTaskCount();
          this.fetchNewNotificationCount();
          this.fetchNewWhatsAppNotificationCount();
          this.getClinicSettingsExistenceErrors();
        }
      },
      immediate: true,
    },
    '$route.name': {
      immediate: true,
      handler(name) {
        this.subNavigation = [];
        const item = this.findNavigateItem(this.navigateItems, name);
        this.setTitleTab(item, name);
        if (item) {
          this.currentNavigateItemName = item.name;
        }
      },
    },
  },

};
</script>
<style lang="scss">
@use "@/scss/buttons";
.clinic-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  &__left-side-menu {
    background-color: #323c47;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
    z-index: 4;
    position: relative;
    width: 155px;
    overflow-y: auto;
    &__item {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 10px;
      padding-inline: 10px;
      height: 50px;
      min-height: 50px;
      justify-content: flex-start;
      width: 100%;
      z-index: 3;
      transition: background-color var(--animate-duration);
      text-decoration: none;
      position: relative;
      cursor: pointer;
      &.current {
        background-color: #252e37;
      }
      &.prompt:hover .clinic-panel__left-side-menu__prompt {
        display: flex;
      }
      &:hover {
        background-color: #252e37;
      }
      &__link {
        color: #eaeff3 !important;
        font-size: 14px;
        font-weight: 400;
        line-height: 13px;
        max-width: 90%;
        text-align: center;
        text-decoration: none;
      }
      &__icon {
        flex-shrink: 0;
        width: 19px;
        height: 19px;
        background-size: contain;
        &.help-item {
          width: 24px;
          height: 24px;
        }
      }
      &__appointment-counter {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        background-color: white;
        color: #0d799f;
        font-size: 12px;
        font-weight: bold;
        border-radius: 50%;
        width: 1.2rem;
        height: 1.2rem;
        text-align: center;
      }
      &__exclamation-mark-alert {
        position: absolute;
        top: 0;
        right: 25px;
        font-size: 24px;
        font-weight: 600;
        color: #f21e1e;
      }
    }
    &__prompt {
      display: none;
      position: fixed;
      bottom: 60px;
      left: 67px;
      color: rgba(0,0,0,.8) !important;
      border: 1px solid;
      background-color: white;
      padding: 5px;
      width: 260px;
      z-index: 2;
      font-size: 16px;
      line-height: 16px;
    }
    &__sub {
      margin: 0;
      padding: 0;
      background-color: #252e37;
      bottom: 0;
      left: 155px;
      position: absolute;
      top: 0;
      width: 220px;
      z-index: 3;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      &__collapse {
        align-self: flex-end;
        width: 24px;
        height: 24px;
        background-image: url("@/assets/img/collapse.svg");
        background-size: contain;
        background-repeat: no-repeat;
        margin: 9px 10px;
        opacity: 0.8;
        transition: opacity var(--animate-duration);
        &:hover {
          opacity: 1;
        }
      }
      &__link {
        padding: 9px 18px 9px 20px;
        color: #eaeff3 !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-align: left;
        text-decoration: none;
        transition: background-color var(--animate-duration);
        &.last {
          margin-bottom: 16px;
        }
        &.link-alert {
          position: relative;
          .mark-alert {
            top: 18%;
            right: 50px;
          }
        }
        &:hover {
          background: #1b232d;
        }
        &.router-link-active {
          color: #90a0b7 !important;
          background-color: #1b232d;
        }
      }
    }
  }
  &__body {
    display: flex;
    flex-direction: row;
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  &__idea {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    &__button {
      &-cancel {
        @include buttons.btn-transparent(100%, 2.2rem, 1rem);
      }
      &-submit {
        @include buttons.btn-blue(100%, 2.2rem, 1rem);
        &:disabled {
          background-color: var(--unfocus-color);
          border: 1px solid var(--unfocus-color);
          color: white;
        }
      }
    }
  }
  &__call-list {
    z-index: 3;
    position: absolute;
    right: 10px;
    top: 64px;
    bottom: 10px;
    max-height: 90%;
    overflow: auto;
  }
  &__appointment-copy {
    position: absolute;
    bottom: 40px;
    right: 40px;
    background-color: var(--fill-color);
    z-index: 10;
    padding: 15px;
    border-radius: 10px;
    &::after {
      background-image: url("@/assets/img/status/copy-grey.svg");
    }
    &__title {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      &:before {
        content: '';
        background-image: url("@/assets/img/status/copy-grey.svg");
        background-position: center;
        background-size: contain;
        width: 20px;
        height: 20px;
        display: block;
      }
    }
    &__delete {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 16px;
      min-height: 16px;
      width: 20px;
      height: 20px;
      background-image: url("@/assets/img/exit-grey.svg");
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 12px 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
  &__important-notification {
    color: red;
    padding: 10px;
    a {
      flex-shrink: 0;
    }
  }
}
.messenger-dialog {
  .side-dialog {
    display: flex;
    flex-direction: column;
  }
  &__content {
    max-width: 800px;
    flex-grow: 1;
  }
  &__frame {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
  }
}
.suggestion-idea-popup {
  .v-card > .v-card__title {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
.head-panel {
  &__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px 20px;
    margin-left: auto;
  }
  &__button {
    max-width: 180px;
    @include buttons.btn-transparent(100%, 2rem, 1rem);
    background-color: transparent;
    &.suggestion {
      min-width: 180px;
      height: auto;
      padding: 3px 5px;
    }
  }
}
.head-link {
  margin-right: 15px;
  color: var(--reading-color);
  text-decoration: none;
}
:is(.settings,.cabinet-page, .role-list-page,
.employee-page, .schedule, .service-page) {
  + .on-boarding-window {
    bottom: 100px;
  }
}
.inputErrorMessage {
  color: #B82428;
}
@media print {
  .clinic-panel__left-side-menu {
    display: none;
  }
  #jvlabelWrap {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .head-panel {
    &__buttons {
      flex-wrap: wrap;
    }
  }
}
@media screen and (max-width: 960px) {
  .clinic-panel {
    position: relative;
    overflow: auto;
    &__left-side-menu {
      display: none;
    }
    &__body {
      align-items: flex-start !important;
      overflow: initial;
    }
  }
  .head-panel {
    &__button {
      color: #EAEFF3 !important;
      border: 1px solid #EAEFF3;
      &.suggestion {
        display: none;
      }
    }
  }
  .v-snack:not(.v-snack--absolute) {
    height: initial;
  }
}
@media screen and (max-width: 660px) {
  .clinic-panel {
    &__mobile {
      &__buttons {
        grid-template-columns: auto;
        grid-template-rows: 1fr 1fr;
        row-gap: 10px;
      }
    }
  }
  }
@media screen and (max-width: 480px) {
  .clinic-panel {
    &__body {
      overflow: auto;
    }
    &__mobile {
      display: block;
    }
    &__idea {
      &__buttons {
        grid-template-columns: 1fr;
        gap: 10px;
        width: 100%;
      }
    }
  }
  :is(.settings,.cabinet-page, .role-list-page,
  .employee-page, .schedule) {
    + .on-boarding-window {
      bottom: 80px;
    }
  }
  .service-page {
    + .on-boarding-window {
      bottom: 140px;
    }
  }
}
</style>
